import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";

const AccountRowContextMenu = (props) => {
  const onCopyClick = async (event) => {
    event.stopPropagation();
    await navigator.clipboard.writeText(props.targetValue);
    props.onClose();
  };

  const onDeleteClick = (event) => {
    event.stopPropagation();
    props.onDelete();
    props.onClose();
  };

  const onEditClick = (event) => {
    event.stopPropagation();
    props.onEdit();
    props.onClose();
  };

  return (
    <Menu
      className={props.className}
      open={props.contextMenu !== null}
      onClose={props.onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        props.contextMenu !== null
          ? { top: props.contextMenu.mouseY, left: props.contextMenu.mouseX }
          : undefined
      }
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <MenuItem onClick={onCopyClick}>
        <ListItemIcon>
          <ContentCopyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Copy</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={onEditClick} disabled={!props.canEdit}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Edit</ListItemText>
      </MenuItem>
      <MenuItem onClick={onDeleteClick} disabled={!props.canDelete}>
        <ListItemIcon>
          <DeleteIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default styled(AccountRowContextMenu)(
  ({ theme }) => `
  & .MuiPaper-root {
    width: 150px;
  }
`,
);
